import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './PasswordStrengthMeter.css';

const STRENGTH_LABELS = ['Very weak', 'Weak', 'So-so', 'Good', 'Great!'];

export default function PasswordStrengthMeter({ score }) {
    const hasScore = score !== null && score !== undefined;
    const level = hasScore ? score : 0;
    return (
        <div className={css.wrapper}>
            <div className={css.track} />
            <div data-testid="password-strength-meter" className={classNames(css.bar, css[`barScore${level}`])} />
            {[1, 2, 3].map(i => (
                <div key={i} className={classNames(css.separator, css[`separator${i}`])} />
            ))}
            <div
                data-testid="password-strength-label"
                className={classNames(css.label, { [css[`labelScore${level}`]]: hasScore })}
            >
                {hasScore ? STRENGTH_LABELS[level] : ''}
            </div>
        </div>
    );
}

PasswordStrengthMeter.propTypes = {
    score: PropTypes.number,
};
